const moduleName = "Facturación";

const CREATE_ADMIN_INVOICE = "Crear factura admin";

export default {
  moduleName,
  CREATE_ADMIN_INVOICE
};
